import React from 'react';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import type { ProductVariantReplacement } from '@eliadmin/core/src/api/products/types/product-types';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

// Type for replacedBy item
export type ReplacedByItem = ProductVariantReplacement;

export function ProductReplacedBy({ replacedBy }: { replacedBy: ReplacedByItem[] }) {
  const generalLayout = useGlobalStore(s => s.generalLayout);
  const { t } = useTranslations();
  if (!replacedBy || replacedBy.length === 0) return null;

  return (
    <Container className="space-y-4 px-0">
      <div className="text-sm font-semibold">This article has been replaced</div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto border-collapse text-sm">
          <thead>
            <tr className="border-b bg-muted/50">
              <th className="p-2 text-left">Article No.</th>
              <th className="p-2 text-left">Name</th>
              <th className="p-2 text-left">Price</th>
            </tr>
          </thead>
          <tbody>
            {replacedBy.map((item, idx) => {
              const code = item.code || '';
              const name = item.product?.name || 'Name missing';
              const slug = item.product?.slug || 'spareparts';
              const priceDisplay = getProductPriceDisplay(item);
              return (
                <tr
                  key={item.id || idx}
                  className="cursor-pointer border-b text-xs hover:bg-muted/30"
                  onClick={() => window.open(`/${slug}`, '_blank')}
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      window.open(`/${slug}`, '_blank');
                    }
                  }}
                >
                  <td className="p-2 font-mono">{code}</td>
                  <td className="p-2">{name}</td>
                  <td className="p-2">
                    {priceDisplay.priceOnRequest
                      ? t('text2278')
                      : formatPrice(
                          priceDisplay.currentWithVat,
                          generalLayout.currency,
                          generalLayout.currency_settings,
                        )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Container>
  );
}
